import axios from "axios";
import config from "../config";
import * as CryptoJS from "crypto-js";

function decryptWithCryptoJS(txtToDecrypt) {
  const apiKey = process.env.REACT_APP_SESSION_KEY;
  let _key = apiKey;
  return CryptoJS.AES.decrypt(txtToDecrypt, _key).toString(CryptoJS.enc.Utf8);
}

function getDecryptedSessionItem(key) {
  const encryptedValue = sessionStorage.getItem(key);
  return encryptedValue ? decryptWithCryptoJS(encryptedValue) : null;
}

export const findProductsByBatchNumber = async (batch) => {
  try {
    const header = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    };
    const url = `${getDecryptedSessionItem(
      "server"
    )}/search-by-batch?batch=${batch}`;
    const response = await axios.get(url, header);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const postAddAssociations = async (associations) => {
  try {
    const header = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    };
    const url = `${getDecryptedSessionItem("server")}/add-associations`;
    const response = await axios.post(url, associations, header);
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const postAddBatch = async (body) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("Token")}`,
    };
    // console.log("header", headers, body);
    const url = `${getDecryptedSessionItem("server")}/product/import`;
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    return { status: "error", error };
  }
};
